import settingsService from '@/services/settingsService'

export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPasswordOld = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorPassword = (password, minLength = 8, maxLength = null) => {
  if (!password || typeof password !== 'string') {
    return false
  }

  // Получаем настройки из сервиса
  const specialChars = settingsService.getSettings('common.regexp_password_special_characters')
  const allowedSymbols = settingsService.getSettings('common.regexp_password_symbols')

  // Экранируем специальные символы для регулярного выражения
  const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const escapedSpecialChars = escapeRegExp(specialChars)

  // Формируем шаблон регулярного выражения
  const regexPattern = maxLength
    ? `^[${allowedSymbols}${escapedSpecialChars}]{${minLength},${maxLength}}$`
    : `^[${allowedSymbols}${escapedSpecialChars}]{${minLength},}$`

  try {
    // Создаем регулярное выражение и проверяем пароль
    const regExp = new RegExp(regexPattern)
    return regExp.test(password)
  } catch (e) {
    console.error('Ошибка в regex валидации пароля:', e)
    return false
  }
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}
